'use strict';

/**
 * @function handleReviewRating
 * @description
 * Handles click events on Bazaarvoice rating/review stars and sub-containers.
 * - Scrolls to the reviews section or triggers review tab if needed.
 * - Handles navigation for compare product ratings.
 */
const handleReviewRating = function () {
    // Handle click on main rating stars (outside quick shop panel)
    $(document).on('click', '.bv_stars_component_container', function (e) {
        const $this = $(this);
        if (!$this.parents().hasClass('quick-shop-panel')) {
            e.preventDefault();
            e.stopPropagation();

            // If reviews section is hidden, trigger the tab to show it
            if ($('#reviews').css('display') === 'none' || $('#reviews').css('display') !== 'block') {
                $('[aria-controls$="reviews"]').trigger('click');
            }

            handleReviewRatingClick($this);

            // If not in compare rating, scroll to reviews section
            if (!$this.parents().hasClass('product-compare-rating')) {
                const reviewsOffset = $('#reviews').offset();
                $('html, body').stop(true, true).animate({
                    scrollTop: reviewsOffset.top - 100
                }, 1000);
            }
        }
    });

    // Handle click on sub-container in compare product section
    $(document).on('click', '.bv_sub_container', function (e) {
        const $this = $(this);
        if ($this.parents().hasClass('product-compare-rating')) {
            e.preventDefault();
            e.stopPropagation();
            handleReviewRatingClick($this);
        }
    });


    /**
     * @function handleReviewRatingClick
     * @description Handles logic for review/rating click in compare product section.
     * @param {jQuery} $element - The clicked element.
     */
    function handleReviewRatingClick($element) {
        const $parentElement = $element.parents('li');
        const liIndex = $parentElement.index() + 1;

        if ($element.parents().hasClass('product-compare-rating')) {
            if (liIndex === 1 && !$('.compare-rating-updated').length) {
                // Scroll to reviews section for the first compare item
                const reviewsOffset = $('#reviews').offset();
                $('html, body').stop(true, true).animate({
                    scrollTop: reviewsOffset.top - 100
                }, 1000);
            } else {
                // For other compare items, navigate to the product's review section
                let locationURL = $element.parent('.bv_main_container').attr('href');
                window.location.href = locationURL;
            }
        }
    }
}


/**
 * @function init
 * @description Initializes rating and review scroll logic for product compare.
 */
export default {
    init: function () {
        handleReviewRating();
    }
};